import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=1277dfc9&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"
import style0 from "./Verify.vue?vue&type=style&index=0&id=1277dfc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1277dfc9",
  null
  
)

export default component.exports